import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import AuthService from "../../admin/components/util/AuthService";

const ProfileDropdown = () => {
    const user = AuthService.getUserData() || {};
    const avatar = localStorage.getItem("owner_avatar") || "";
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => setIsProfileDropdown(!isProfileDropdown);

    return (
        <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
            <DropdownToggle tag="button" type="button" className="btn">
                <span className="d-flex align-items-center">
                    {avatar ? (
                        <img src={avatar} alt="" className="rounded-circle object-fit-cover" style={{ width: 35, height: 35, border: "2px solid #E5A325" }} />
                    ) : (
                        <span className="rounded-circle header-profile-user d-flex align-items-center justify-content-center"
                            style={{ width: 35, height: 35, background: "rgba(229,163,37,0.15)", color: "#E5A325", fontWeight: 700, fontSize: 14 }}>
                            {(user.name || "U").charAt(0).toUpperCase()}
                        </span>
                    )}
                    <span className="text-start ms-xl-2">
                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{user.name || "Usuário"}</span>
                        <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{user.role === "owner" ? "Proprietário" : user.email || ""}</span>
                    </span>
                </span>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
                <h6 className="dropdown-header">Bem Vindo, {user.name || "Usuário"}!</h6>
                <DropdownItem href="/admin/profile">
                    <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                    <span className="align-middle">Perfil</span>
                </DropdownItem>
                <div className="dropdown-divider"></div>
                <DropdownItem href="/logout">
                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                    <span className="align-middle">Sair</span>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default ProfileDropdown;
